// extracted by mini-css-extract-plugin
module.exports = {"space":"Pendientes1_space__fHT7t","rowClass":"Pendientes1_rowClass__3YNh6","precioFinal":"Pendientes1_precioFinal__2sVZG"};